import { render, staticRenderFns } from "./DeviceTotal.vue?vue&type=template&id=71e64650&scoped=true&"
import script from "./DeviceTotal.vue?vue&type=script&lang=js&"
export * from "./DeviceTotal.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTotal.vue?vue&type=style&index=0&id=71e64650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e64650",
  null
  
)

export default component.exports